import { createAsyncThunk } from '@reduxjs/toolkit';
import { RouteParamsType } from '../../types/utils/router-params.type';
import axios from 'axios';
import { rejectWithApiError } from '../../utils/api';
import { RootReducerState } from '../../redux/Reducers';

export const getPotscastLogsList = createAsyncThunk<Array<any>, RouteParamsType, { state: RootReducerState }>(
  'potscast/getPotscastLogsList',
  async (params, thunkAPI) => {
    try {
      const queryString = Object.keys(params)
        .map(key => key + '=' + params[key])
        .join('&');

      const response = await axios.get<Array<any>>(
        `${process.env.REACT_APP_API_URL}/acs/potscast-logs/${queryString ? `?${queryString}` : ''}`
      );
      return response.data;
    } catch (error) {
      return rejectWithApiError({ thunkAPI, error, fallback: 'Error during fetching logs list!' });
    }
  }
);
